import React from 'react'
import '../stylesheets/landingPageStyles.css'
import { Link, useLocation } from 'react-router-dom'
import CrmActions from '../../Shared Components/Crm/crmAction'
import { LineSkeleton, ButtonSkeleton } from '../../Skeletons/skeletonTemplates';
import { gtagHelperFunction } from "../Shared Components/gtagHelperFunction"
import CourseThumbnail from './courseThumbnail'
import { setInitiatePayment } from '../utils';
import SalesTimer from '../salesTimer';
import { useSelector} from "react-redux";
import { SALE_ACTIVE } from '../../urls';


export default function CourseCard(props) {
    const {search} = useLocation();
    const { theme } = useSelector((state) => state);
    var handleToUpdate = props.handleUpdate;
    var handleFillDetailsUpdate = props.handleFillDetailsUpdate;

    function handleRegisteredUser(record) {
        CrmActions.updateUserAction(props.data.course_id, record.batch_id, 1, 1);
        handleToUpdate(record)
        handleFillDetailsUpdate(record);
    }

    function  convertToGrouping(data) {
        return String(data).padStart(2, "0");
    };

    function fetchOnlineCourseButton() {
        let firstUpcomingBatchExists = (Object.keys(props.data.first_batch).length > 0);
        if (!props.hasBatch || !firstUpcomingBatchExists) {
            return (<button disabled className="btn btn-danger btn-lg w-100 pt-3 pb-3 sofia-pro customButtonFont">No Active Batches</button>);
        }
        var record = {
            "batch_id": props.data.first_batch.batch_id,
            "batch_name": props.data.first_batch.batch_name,
            "start_date": props.data.first_batch.reg_start_date,
            "batch_slug": props.data.first_batch.batch_slug,
            "show_invite_code_block": props.data.first_batch.show_invite_code_block,
            "warning_message" : props.data.first_batch.warning_message
        }
        var data = props.data.button_actions.register_btn
        var action = props.data.button_actions.register_btn.action
        var sub_action = props.data.button_actions.register_btn.sub_action
        var button;
        if (action === "user_already_registered_in_batch") {
            if (sub_action === "show_tracks")
                button = <a href={props.data.button_actions.register_btn.extra.batch_url} className="btn btn-success btn-lg w-100 sofia-pro">Start Course</a>
            else if (sub_action === "fee_paid_batch_not_started")
                button = <button disabled className="btn btn-success btn-lg w-100">Batch not Started</button>
            else if (sub_action === "subscribed") //to be discussed
                button = (<div>
                    <button onClick={() => {
                gtagHelperFunction("click","course_payfee_top",window.location.href)
                handleRegisteredUser(record)
                setInitiatePayment()}} className="btn btn-success btn-lg w-100 sofia-pro">Pay Fee</button>
                </div>
                )
            else if (sub_action === "pay_fee")
                button = (<div>
                    <button onClick={() => {
                gtagHelperFunction("click","course_payfee_top",window.location.href)
                handleRegisteredUser(record)
                setInitiatePayment()}} className="btn btn-success btn-lg w-100 sofia-pro">Pay Fee</button>
                </div>
                )
            else if (sub_action === "attend_contest")
                button = <a href={data.extra.contest_url} className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Attend Contest</a>
            else if (sub_action === "payment_link_will_open_on")
                button = <button disabled className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Payment Link opens on {data.extra.payment_start_date.split("T")[0]}</button>
            else if (sub_action === "payment_link_closed")
                button = <button disabled className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Payment Link Closed</button>
            else if (sub_action === "no_seats_available")
                button = <button disabled className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Seats not available</button>
            else if (sub_action === "registration_closed")
                button = <button disabled className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Registration Closed</button>
        } else if (action === "registration_not_started") {
            button = <button disabled className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Registration not started</button>
        } else if (action === "registration_closed") {
            button = <button disabled className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Registration Closed</button>
        } else if (action === "registration_open") {
            if (sub_action === "subscribe")
                button = <button onClick={() => handleToUpdate(record)} disabled className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Subscribe</button>
            else if (sub_action === "sign_up_now")
                button = <button onClick={() => {
                    gtagHelperFunction("click","course_signup_top",window.location.href)
                    handleToUpdate(record)
            }} className="btn btn-success btn-lg sofia-pro w-100 pt-3 pb-3 customButtonFont sofia-pro">Sign-Up Now</button>
            else if (sub_action === "login_to_subscribe")
                button = <a href={`${window.location.href}?loginMode=${record.batch_id}`} className="btn btn-success btn-lg w-100 pt-3 pb-3 login-modal-btn customButtonFont sofia-pro">Login to Subscribe</a>
            else if (sub_action === "login_to_register")
                button = <a href={`${window.location.href}?loginMode=${record.batch_id}`} className="btn btn-success login-modal-btn btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro" onClick={()=>gtagHelperFunction("click","course_loginreg_top",window.location.href)}>Login to Register</a>
            else if (sub_action === "registration_closed")
                button = <button disabled className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Registration Closed</button>
            else if (sub_action === "free_course")
                if(props.autoRegisterForFree){
                     button = <a href={`/batch/${props?.data?.first_batch?.batch_slug}`} onClick={() => {
                                gtagHelperFunction("click","course_reg_top",window.location.href)}} className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Register Now
                            </a>
                }
                else{
                    button = <button onClick={() => {
                                gtagHelperFunction("click","course_reg_top",window.location.href); handleToUpdate(record)}} className="btn btn-success btn-lg w-100 pt-3 pb-3 customButtonFont sofia-pro">Register Now
                            </button>
                }
        }
        return button;
    }

    function fetchLiveCourseButton() {
        if (props.hasBatch)
            return (<Link to={{
                            pathname: `/payments/${props.courseSlug}`,
                            search: search
                            }} 
                        className="btn btn-success sofia-pro btn-lg w-100 pt-3 pb-3 customButtonFont" onClick={() => {
                gtagHelperFunction("click","course_reg_top",window.location.href)
        }}>Register Now</Link>)
        else 
            return (<button disabled className="btn btn-danger btn-lg w-100 pt-3 pb-3 sofia-pro customButtonFont">No Active Batches</button>)
    }
    
    /* Button to register for the contest */
    function fetchRegisterButton() {
        if (props.data.courseType === 1) {
            if (props.data.button_actions.action === "checkout_previous_batches")
                return (
                    <div className="alignStartEndDate float-left">
                        <button disabled className="btn btn-danger w-100 btn-lg pt-3 pb-3 sofia-pro customButtonFont">No Active Batches</button>
                    </div>
                )
            return (
                <div className="my-auto alignStartEndDate">
                    {fetchOnlineCourseButton()}
                </div>
            );
        } else {
            if (props.data.total_upcoming_batches === 1)
                return (
                    <div className="col-12 pl-0 alignStartEndDate">
                        {fetchOnlineCourseButton()}
                    </div>
                )
            return (
                <div className="col-12 pl-0 alignStartEndDate">
                    {fetchLiveCourseButton()}
                </div>
            )
        }
    }

    function fetchDemoTrackButton(){
        var sub_action = props.data.button_actions.register_btn.sub_action
        let button;
        if(sub_action === "show_tracks"){
            button = "";
        }
        else if (sub_action === "login_to_register")
            button = <a className="demobtn login-modal-btn" href={`${window.location.href}?loginMode=${props.data.first_batch.batch_id}`} onClick={()=>gtagHelperFunction("click","course_loginreg_top",window.location.href)}>
                        {theme==="light"? <img className='play-button' src="https://media.geeksforgeeks.org/img-practice/blueplay1(1)-1674191884.png"  alt='play-button'/>: <img src='https://media.geeksforgeeks.org/img-practice/prod/courses/4/Web/Content/Play_1688124474.svg' alt='play-button'/>}
                        <div className='demodiv'>
                            <span className='demowatch'>Explore</span>
                            <span className='demotrack'>For Free</span>
                        </div>
                    </a>    
        else    
            button = <a className="demobtn" id="demo_explore" href={`/batch/${props?.data?.first_batch?.batch_slug}`} target="_blank">
                        {theme==="light"? <img className='play-button' src="https://media.geeksforgeeks.org/img-practice/blueplay1(1)-1674191884.png"  alt='play-button'/>: <img src='https://media.geeksforgeeks.org/img-practice/prod/courses/4/Web/Content/Play_1688124474.svg' alt='play-button'/>}
                        <div className='demodiv'>
                            <span className='demowatch'>Explore</span>
                            <span className='demotrack'>For Free</span>
                        </div>
                    </a>

        return button;
    }

    return (
      <section id="mainCourseCard">
        {/* Course card design goes here */}
        <div className="card courseCardBorders">
          {props.data.course_fee_type === 1 && props.salesText && (
            <img
              className="offerRibbon"
              src="https://media.geeksforgeeks.org/img-practice/on_offer_ribbon-1680614058.svg"
              alt=""
            />
          )}
          <div className="row">
            {/* Loads the image associated with the course */}
            <div className="col-md-5 icon-size img-skeleton">
              <CourseThumbnail video={props.data.videoLink} />
            </div>
            {props.salesText &&
            props.currentDate &&
            props.data.course_fee_type !== 0 ? (
              <div className="salesTimerContainerMob">
                {/* <div>
                <span className="timerValue">{convertToGrouping(props.salesTimerData.days)}</span>
                                <span className="timerSeparator">:</span>
                <span className="timerValue">{convertToGrouping(props.salesTimerData.hours)}</span>
                                <span className="timerSeparator">:</span>
                                <span className="timerValue">{convertToGrouping(props.salesTimerData.minutes)}</span>
                                <span className="timerSeparator">:</span>
                                <span className="timerValue">{convertToGrouping(props.salesTimerData.seconds)}</span>
              </div> */}
                <SalesTimer
                  urgencyStartTime={props?.urgencyData?.startTime}
                  urgencyEndTime={props?.urgencyData?.endTime}
                  seperatorStyle={{ color: "white" }}
                  currentDate={props.currentDate}
                />
              </div>
            ) : null}
            {/* Sets up the content for the course inside of the card */}
            <div className="col-md-7 alignCardMeta">
              <div
                className="card-body customPadding mb-3"
                style={{ width: "100%" }}
              >
                {props.data.visit_count && (
                  <div className="intrested-count">
                    {theme === "light"? <img
                      alt="interested count"
                      src="https://media.geeksforgeeks.org/img-practice/Interested(1)-1669185704.svg"
                    /> : <img
                      alt="interested count"
                      src="https://media.geeksforgeeks.org/img-practice/prod/courses/1/Web/Content/visit_count_2_1687863297.png"
                    /> }{" "}
                    {props.data.visit_count} interested Geeks
                  </div>
                )}
                <p
                  className="text-left font-weight-bold mt-1 sofia-pro cardHeadingSize"
                  style={{ marginBottom: "8px" }}
                >
                  Course Description
                </p>
                {props.data.content ? (
                  <div
                    className="card-text text-left mb-3 sofia-pro text-muted descriptionSize"
                    dangerouslySetInnerHTML={{ __html: props.data.content }}
                  />
                ) : (
                  <div className="mb-3">{LineSkeleton(7)}</div>
                )}
                <div className="mb-3 course-stats">
                  {props.data.level && (
                    <span>
                      {theme === "light"?
                      <img
                        alt="level"
                        src="https://media.geeksforgeeks.org/img-practice/level-1668679601.svg"
                      /> : 
                      <img
                        alt="level"
                        src="https://media.geeksforgeeks.org/img-practice/prod/courses/3/Web/Content/course_level_1687864113.png"
                      />}
                      {props.data.level}
                    </span>
                  )}
                  {props.data.course_duration && (
                    <span>
                     {theme === "light" ?
                      <img
                        alt="course duration"
                        src="https://media.geeksforgeeks.org/img-practice/time-1668679645.svg"
                      />
                      : <img src="https://media.geeksforgeeks.org/img-practice/prod/courses/1/Web/Content/Star Rating_1688112654.svg" alt='course duration'/>
                     }
                      {props.data.course_duration}
                    </span>
                  )}
                  {props.data.seats_left && (
                    <span style={{ color: "#D87C04" }}>
                      <img
                        alt=""
                        src="https://media.geeksforgeeks.org/img-practice/seatsleft-1669094948.svg"
                      />
                      {props.data.seats_left} Seats Left
                    </span>
                  )}
                </div>
                <div className="row courseActionButtons">
                  <div className="col-7 col-sm-6">
                    {props.data.button_actions ? (
                      fetchRegisterButton()
                    ) : (
                      <ButtonSkeleton type="btn-skeleton-sm" />
                    )}
                  </div>
                  <div className="DemobtnDiv">
                    {props.data.button_actions ? (
                      props?.data?.first_batch &&
                      props?.data?.first_batch?.is_demo_batch &&
                      fetchDemoTrackButton()
                    ) : (
                      <ButtonSkeleton type="btn-skeleton-sm" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {props.data.other_benefits && props.data.other_benefits.length > 0 && (
          <div className="col-10 offset-1 course_other_benefits">
            {props.data.other_benefits.slice(0, 4).map((benefit) => {
              return <span>{benefit.title}</span>;
            })}
          </div>
        )}
        {props.data.default_coupon && props.data.default_coupon.length > 0 && (
          <div className="mt-5 col-12 mx-auto w-100">
            <div className="row mx-auto">
              <div className="col-12 my-auto">
                {props.timerData && (
                  <div className="sales_timer" style={{ marginTop: "10px" }}>
                    <div>
                      <strong
                        className="timer_desc"
                        style={{ marginRight: "5px", fontSize: "16px" }}
                      >
                        GFG Sale Ends in
                      </strong>
                      <div
                        className="timer_container"
                        style={{ display: "inline" }}
                      >
                        <span className="timer_item">
                          {convertToGrouping(props.timerData.hours)}
                        </span>
                        <span className="timer_separator">:</span>
                        <span className="timer_item">
                          {convertToGrouping(props.timerData.minutes)}
                        </span>
                        <span className="timer_separator">:</span>
                        <span className="timer_item">
                          {convertToGrouping(props.timerData.seconds)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                {
                  props.courseSlug !== "google-cloud-tech-program" &&
                  <div className="col-sm-9 discountSection pb-1 pt-1 pl-3 pr-3 mx-auto">
                    <img
                      className="pr-2 warning-icon"
                      src="https://media.geeksforgeeks.org/img-practice/Group5631-1621599978.png"
                    />
                    {React.createElement("a", {
                      className: "urw-din text-left couponText text-dark",
                      dangerouslySetInnerHTML: {
                        __html: props.data.default_coupon,
                      },
                    })}
                  </div>
                }
              </div>
            </div>
          </div>
        )}
        {props.courseSlug === "google-cloud-tech-program" && 
          <div className="bannerGrid">
            <div className="discountSection">
              <img 
                className="pr-2"
                src="https://media.geeksforgeeks.org/img-practice/prod/courses/1/Web/Content/alarm-clock_1694500227.svg"
                alt="clock"
              />
              <p className="text-left text-base">Registration closing soon!<br /> 
              <b>Live classes starting from 2nd October</b></p>
              </div>
            <div className="discountSection googleSection">
              <section className="googleExclusive">
              <img 
                src="https://media.geeksforgeeks.org/img-practice/prod/dashboard/1/Web/Menu/580b57fcd9996e24bc43c51f 1_1694501077.svg"
                alt="Google"
              />
              {" "}exclusive
              </section>
            <p className="text-left text-sm">Unlock exclusive job opportunities with the <b>Google Bootcamp course</b> and take your career to new heights!</p>
            </div>
          </div>
        }
      </section>
    );
}
